export const VendorErrorSeverity = {
  UNKNOWN_EVENT: 'UNKNOWN_EVENT',
  INFO: 'INFO',
  WARN: 'WARN',
  ERR: 'ERR',
  FATAL: 'FATAL',
} as const;

export type VendorErrorSeverity =
  (typeof VendorErrorSeverity)[keyof typeof VendorErrorSeverity];
